import { useEffect, useState } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { env } from "../../env";

export const useDistanceHook = ({
    from = "Stanisława Sadowskiego 12, 85-151 Bydgoszcz",
    to = ""
} = {}) => {

    const [data, setData] = useState(null);

    const blankValue = {
        distance: { text: null, value: null },
        duration: { text: null, value: null }
    };

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: env.REACT_APP_GOOGLE_MAPS_API_KEY
    });

    useEffect(() => {
        if (!isLoaded || !from || !to) {
            setData(blankValue);
            return;
        }

        let cancelled = false;

        const run = async () => {
            try {
                const { RouteMatrix } = await window.google.maps.importLibrary("routes");

                const response = await RouteMatrix.computeRouteMatrix({
                    origins: [
                        {
                            waypoint: { address: from }
                        }
                    ],
                    destinations: [
                        {
                            waypoint: { address: to }
                        }
                    ],
                    travelMode: "DRIVE",
                    units: "METRIC"
                });

                for await (const route of response) {
                    if (cancelled) return;

                    const result = {
                        distance: {
                            text: route.distanceMeters
                                ? `${(route.distanceMeters / 1000).toFixed(1)} km`
                                : null,
                            value: route.distanceMeters ?? null
                        },
                        duration: {
                            text: route.duration
                                ? `${Math.round(route.duration.seconds / 60)} min`
                                : null,
                            value: route.duration?.seconds ?? null
                        }
                    };

                    setData(result);
                }
            } catch (err) {
                console.error(err);
                if (!cancelled) {
                    setData(blankValue);
                }
            }
        };

        run();

        return () => {
            cancelled = true;
        };

    }, [isLoaded, from, to]);

    return data || blankValue;
};